import {useSiteSettings} from "@/functions/siteSettings";

/**
 * Картинки сайта, которые можно заменить в админке (Сайт → Картинки сайта).
 * Ключ картинки = имя файла, например "about-scheme.svg".
 * Если в админке замена не загружена — показывается стандартная картинка.
 */
const bundled = import.meta.glob("/resources/js/assets/images/*.{svg,png,jpg,jpeg,gif,webp}", {
    eager: true,
    as: "url",
});

const defaults = {};
for (const [path, url] of Object.entries(bundled)) {
    defaults[path.split("/").pop()] = url;
}

/**
 * В компоненте: const siteImg = useSiteImg();  в шаблоне: :src="siteImg('about-scheme.svg')"
 * Для картинок не из сборки можно передать запасной адрес вторым аргументом.
 */
export function useSiteImg() {
    const settings = useSiteSettings("images");
    return (key, fallback) => {
        const overrides = settings.value?.overrides;
        const custom = overrides && !Array.isArray(overrides) ? overrides[key] : null;
        return custom || fallback || defaults[key] || "";
    };
}
